import { CustomViewFormConditionItem } from 'src/graphql/entities/custom-view/custom-view.types';
import { isUnary } from './operators';

export const filterValidCustomViewFilters = (rules: CustomViewFormConditionItem[]) => {
  return rules.filter(isValidRule) ?? [];
};

function isValidRule(rule: CustomViewFormConditionItem) {
  const hasOperator = rule?.operator;
  const hasFieldValue = rule.field?.value;
  const hasValueOrIsEmptyOperator = !!rule.value || isUnary(rule.operator);

  return hasOperator && hasFieldValue && hasValueOrIsEmptyOperator;
}
